import { NgForOf, NgIf } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Injector,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { TuiDialogService } from '@taiga-ui/core';
import { TuiTagModule } from '@taiga-ui/kit';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { CartItem, selectItemQuantityInCart } from '@us/web/cart/data-access';
import { ProductItemModalComponent } from '@us/web/categories/feature';
import { selectItemQuantityInStock } from '@us/web/inventory/data-access';
import { OrderState, OrderStateData } from '@us/web/shared/data-access';
import { NumberGroupComponent } from '@us/web/shared/ui';
import { FormatCurrencyPipe } from '@us/web/shop/data-access';
import { combineLatestWith } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'us-order-item',
    standalone: true,
    imports: [NgIf, TuiTagModule, TranslocoModule, FormatCurrencyPipe, NgForOf, NumberGroupComponent],
    templateUrl: './order-item.component.html',
    styleUrls: ['./order-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderItemComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly dialogService = inject(TuiDialogService);
    private readonly injector = inject(Injector);

    @Input() item!: CartItem;
    @Input() readonly = false;
    @Output() quantityChanged: EventEmitter<number> = new EventEmitter();

    maximumQuantity = Number.MAX_VALUE;

    readonly OrderStateData = OrderStateData;
    readonly OrderState = OrderState;

    ngOnInit() {
        this.store
            .select(selectItemQuantityInStock(+this.item.product_id))
            .pipe(
                untilDestroyed(this),
                combineLatestWith(this.store.select(selectItemQuantityInCart(this.item.product_id)))
            )
            .subscribe(([quantityInStock, quantityInCart]) => {
                if (quantityInStock === -1) {
                    this.maximumQuantity = Number.MAX_VALUE;
                } else {
                    this.maximumQuantity = Math.floor(
                        (quantityInStock - quantityInCart) / this.item.unit?.ratio + this.item.quantity
                    );
                }
                this.changeDetectorRef.markForCheck();
            });
        // TODO: promotion
        // this.store.select(selectCart).subscribe(cart => {
        //     this.foods = cart.productList ?? [];
        // });

        if (
            this.item.extra_discount &&
            this.item.extra_discount['promotion_type'] === 0 &&
            (this.item.extra_discount['promotion_subtype2'] === 0 ||
                this.item.extra_discount['promotion_subtype2'] === 1 ||
                this.item.extra_discount['promotion_subtype2'] === 2)
        ) {
            // tặng món
            this.readonly = true;
        }
    }

    onChangeItemQuantity(quantity: number): void {
        if (quantity < 1 || quantity > this.maximumQuantity) {
            return;
        }
        this.quantityChanged.emit(quantity);
    }

    async onEdit() {
        if (this.readonly || this.item.version_code > 0) {
            return;
        }

        this.dialogService
            .open<void>(new PolymorpheusComponent(ProductItemModalComponent, this.injector), {
                data: {
                    productId: Number(this.item.product_id),
                    selectedValue: this.item
                },
                dismissible: true,
                size: 'page'
            })
            .subscribe();
    }

    onDeleteItem(e: MouseEvent) {
        e.stopPropagation();
        this.quantityChanged.emit(0);
    }

    openChooseProduct(cartItem: CartItem) {
        // const foods = this.foods.filter(i => i.category_id && i.category_id === +cartItem.product_id);
        // this.dialogService
        //     .open(new PolymorpheusComponent(PromotionProductComponent, this.injector), {
        //         data: {
        //             foods,
        //             item: cartItem
        //         },
        //         dismissible: false,
        //         closeable: false,
        //         size: 'fullscreen',
        //         label: 'Chọn sản phẩm tặng'
        //     })
        //     .subscribe();
    }
}
